import React from 'react';
import { findDOMNode } from 'react-dom';
import { TimelineLite } from 'gsap';
import ScrollMagic from 'scrollmagic';

export default {

    initialise(NavDesktop) {
        this.NavDesktopNode = findDOMNode(NavDesktop);
        this.navBg = this.NavDesktopNode.getElementsByClassName('nav-bg');
        this.subNavBgAnimated = this.NavDesktopNode.getElementsByClassName('subnav-bg-animated');

        this.buildEnterTl();
        this.buildLeaveTl();
    },

    didUpdate(NavDesktop) {
        this.initialise(NavDesktop);
        this.toggleMainNav();
    },

    handleMouseEnter(event, NavDesktop) {
        this.initialise(NavDesktop);

        if (!this.isMenuOpen()) {
            this.enterTl.restart();
            this.enterTl.play();
        }
    },

    handleSubNavMouseEnter(event) {
        let el = event.currentTarget,
            subNav = [...el.getElementsByTagName('ul')],
            tl = new TimelineLite();

        subNav.map((innerEl) => {
            tl.set(innerEl, {height: 'auto', display: 'block'});
            tl.fromTo(innerEl, 1.2, {height: 0}, {height: innerEl.offsetHeight + 'px', ease: Elastic.easeOut.config(1, 0.8)});
        });
    },

    handleSubNavMouseLeave(event) {
        let el = event.currentTarget,
            subNav = [...el.getElementsByTagName('ul')],
            tl = new TimelineLite();

        subNav.map((innerEl) => {
            tl.to(innerEl, 0.3, {height: 'auto', ease: Power3.easeOut})
                .set(innerEl, {display: 'none', height: 'auto'});
        });
    },

    resetNavigation(NavDesktop) {
        this.enterTl.clear();
        this.leaveTl.clear();
        this.initialise(NavDesktop);
    },

    toggleMainNav() {
        let that = this,
            controller = new ScrollMagic.Controller();

        new ScrollMagic.Scene({
            offset: 72,
            reverse: true
        })
            .addTo(controller)
            .on('enter', function(){
                if (!that.isMenuOpen()) {
                    that.enterTl.restart();
                    that.enterTl.play();
                }
            })
            .on('leave', function(){
                that.leaveTl.restart();
                that.leaveTl.play();
            });

        /*
            There is a situation where scrolling down then up really quickly breaks the nav
            So this scene will detect that bug, and force the nav to scroll down at a certain point (the offset)
        */
        new ScrollMagic.Scene({
            offset: 600,
            reverse: false
        })
            .addTo(controller)
            .on('enter', function(){
                if (that.navBg[0].style.height === '0%') {
                    that.enterTl.kill();
                    that.buildEnterTl();
                    that.enterTl.play();
                }
            })
    },

    buildEnterTl() {
        let that = this;
        this.enterTl = new TimelineLite({paused: true});

        this.enterTl.add(function(){
            that.NavDesktopNode.classList.add('open');
        })
            .to(this.navBg, 1, {height: '100%', ease: Elastic.easeOut.config(1, 0.4)})
            .to(this.subNavBgAnimated, 1, {height: '100%', ease: Elastic.easeOut.config(1, 0.4)}, 0);
    },

    buildLeaveTl() {
        let that = this;
        this.leaveTl = new TimelineLite({paused: true});

        this.leaveTl.add(function(){
            that.NavDesktopNode.classList.remove('open');
        })
            .to(this.navBg, 0.5, {height: '0%', ease: Power3.easeOut})
            .to(this.subNavBgAnimated, 0.5, {height: '0%', ease: Power3.easeOut}, 0);
    },

    isMenuOpen() {
        return this.NavDesktopNode.classList.contains('open');
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/layout/NavDesktop/animations.js